// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2r7GB","title":"AfterFrontImage_title__1sZVq"};